import { render, staticRenderFns } from "./BusinessBankTable.vue?vue&type=template&id=4eb17609&"
import script from "./BusinessBankTable.vue?vue&type=script&lang=js&"
export * from "./BusinessBankTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports